<ion-button
  [disabled]="disabled"
  [expand]="expand"
  [color]="buttonColor"
  [fill]="fill"
  [size]="size"
  [shape]="shape"
  [class.link]="category === 'link'"
  (click)="onButtonClick()"
  [type]="buttonType"
  [attr.routerLink]="routerLink"
  [href]="href"
>
  <ion-icon
    *ngIf="icon"
    [name]="icon"
    [slot]="iconSlot"
    [size]="size"
    [attr.aria-label]="category === 'icon-only' ? ariaLabel : ''"
    data-testid="button-icon"
  ></ion-icon>
  <ion-label
    *ngIf="category !== 'icon-only'"
    [attr.aria-label]="ariaLabel"
    [class]="getFontClass()"
    [class.left-aligned-button]="alignLeft"
    [class.top-aligned-button]="alignTop"
    data-testid="button-label"
  >
    <ng-content></ng-content>
  </ion-label>
</ion-button>
